import { useListUsersQuery } from "metabase/api";
import {
  PERSONAL_COLLECTIONS,
  ROOT_COLLECTION,
} from "metabase/common/collections/constants";
import { CollectionListView } from "metabase/common/components/CollectionListView";
import { usePageTitle } from "metabase/hooks/use-page-title";
import * as Urls from "metabase/urls";
import type { IconName } from "metabase-types/api";

export const UserCollectionList = () => {
  usePageTitle(PERSONAL_COLLECTIONS.name, { titleIndex: 1 });

  const { data, isLoading } = useListUsersQuery({});

  const users = data?.data ?? [];

  const crumbs = [
    {
      title: ROOT_COLLECTION.name,
      to: Urls.collection({ id: "root", name: "" }),
    },
    { title: PERSONAL_COLLECTIONS.name },
  ];

  const items = users
    .filter((user) => user.personal_collection_id)
    .map((user) => ({
      key: user.personal_collection_id,
      name: user.common_name,
      icon: "person" as const satisfies IconName,
      link: `/collection/${user.personal_collection_id}`,
    }));

  return (
    <CollectionListView crumbs={crumbs} loading={isLoading} items={items} />
  );
};
